<template>
  <div>
    <b-navbar id="navbarTop" toggleable="lg" type="dark">
      <b-row align-v="center">
        <b-col cols="9">
          <b-nav-text style="padding-left: 35%;color: white;letter-spacing: 0.8px;font-size: 150%"><b>{{this.$router.currentRoute.name}}</b></b-nav-text>
        </b-col>
        <b-col cols="3">
          <button type="button" class="close" style="padding-right: 50%;" v-on:click="close">
            <span style="color: white; font-size: 150%;">&times;</span>
          </button>
        </b-col>
      </b-row>
    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: "navbar-top-menu",
    methods: {
      close: function() {
        this.$router.push("/dashboard");
      }
    }
  };
</script>

<style scoped>
  #navbarTop {
    background-color: #2B2D42;
    z-index: 1000;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
    display: block;
    position: fixed;
    top: 0;
  }
</style>
